/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { RootLayout } from '../root-layout/root-layout';
import { ToolbarOptions } from '../root-layout/toolbar-options';

@Component({
  selector: 'gh-toolbar-options',
  template: require('./toolbar-options.component.html'),
})
export class ToolbarOptionsComponent implements OnInit, OnDestroy, ToolbarOptions {
  @ViewChild(TemplateRef, { static: false }) templateRef: TemplateRef<any>;

  constructor(private rootLayout: RootLayout) {
  }

  ngOnInit(): void {
    this.rootLayout.setToolbarOptions(this);
  }

  ngOnDestroy(): void {
    this.rootLayout.resetToolbarOptions();
  }
}
